import { FunctionComponent, ReactNode } from 'react';
import { withStyles } from '../../../utils/utils';

import styles from './Title.module.scss';

export type TitleProps = {
  title: ReactNode;
  bold?: boolean;
  center?: boolean;
  size?: 'xxsm' | 'xsm' | 'sm' | 'md' | 'lg';
  textSize?: string;
  className?: string;
};

type FC = FunctionComponent<TitleProps>;

const classes = withStyles(styles);

const Title: FC = ({ title, bold, center, size = 'md', textSize, className }: TitleProps) => (
  <h1
    style={{ fontSize: textSize }}
    className={classes('title', size, bold && 'bold', center ? 'center' : 'left', className)}
  >
    {title}
  </h1>
);

export default Title;
